import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-grid gap-2" }
const _hoisted_2 = { class: "p-1" }
const _hoisted_3 = {
  style: {"font-size":"12px"},
  class: "d-flex justify-space-between m-1"
}

import OperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue';
import ManagementOfficeAutoComplete from '@/components/AutoCompletes/ManagementOfficeAutoComplete.vue';
import DepartmentAutoComplete from '@/components/AutoCompletes/DepartmentAutoComplete.vue';
import VehicleAutoComplete from '@/components/AutoCompletes/VehicleAutoComplete.vue';
import DriverAutoComplete from '@/components/AutoCompletes/DriverAutoComplete.vue';
import GroupAutoComplete from '@/components/AutoCompletes/GroupAutoComplete.vue';
import managementOfficeType from '@/types/responses/getManagementOffice';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import operationOfficeType from '@/types/responses/getOperationOffice';
import RangeDatePicker from '@/components/Common/RangeDatePicker.vue';
import departmentResponseType from '@/types/responses/getDepartment';
import vehicleResponseType from '@/types/responses/getVehicle';
import accountResponseType from '@/types/responses/getAccount';
import groupResponseType from '@/types/responses/getGroup';
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchFormContent',
  props: {
    modelValue: {},
    operationOffices: {},
    managementOfficeClearable: { type: Boolean },
    operationOfficeClearable: { type: Boolean },
    isDepartment: { type: Boolean },
    errors: {},
    maxFilterDays: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ManagementOfficeAutoComplete, {
      modelValue: modelValue.value.managementOffice,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.managementOffice) = $event)),
      "error-messages": props.errors.managementOffice,
      selectFirstIfOnlyOne: true,
      clearable: props.managementOfficeClearable
    }, null, 8, ["modelValue", "error-messages", "clearable"]),
    _createVNode(OperationOfficeAutoComplete, {
      modelValue: modelValue.value.operationOffice,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.operationOffice) = $event)),
      managementOffice: modelValue.value.managementOffice,
      "error-messages": props.errors.operationOffice,
      selectFirstIfOnlyOne: true,
      clearable: props.operationOfficeClearable
    }, null, 8, ["modelValue", "managementOffice", "error-messages", "clearable"]),
    _createVNode(GroupAutoComplete, {
      modelValue: modelValue.value.group,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue.value.group) = $event)),
      managementOffice: modelValue.value.managementOffice,
      operationOffices: props.operationOffices,
      "error-messages": props.errors.group
    }, null, 8, ["modelValue", "managementOffice", "operationOffices", "error-messages"]),
    _createVNode(DepartmentAutoComplete, {
      modelValue: modelValue.value.department,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue.value.department) = $event)),
      operationOffices: props.operationOffices,
      "error-messages": props.errors.department,
      selectFirstIfOnlyOne: props.isDepartment
    }, null, 8, ["modelValue", "operationOffices", "error-messages", "selectFirstIfOnlyOne"]),
    _createVNode(VehicleAutoComplete, {
      modelValue: modelValue.value.vehicle,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modelValue.value.vehicle) = $event)),
      selectedDepartment: modelValue.value.department,
      managementOffice: modelValue.value.managementOffice,
      operationOffices: props.operationOffices,
      requestParams: { type: 'filter' },
      "error-messages": props.errors.vehicle
    }, null, 8, ["modelValue", "selectedDepartment", "managementOffice", "operationOffices", "error-messages"]),
    _createVNode(DriverAutoComplete, {
      modelValue: modelValue.value.driver,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modelValue.value.driver) = $event)),
      selectedDepartment: modelValue.value.department,
      operationOffices: props.operationOffices,
      "error-messages": props.errors.driver
    }, null, 8, ["modelValue", "selectedDepartment", "operationOffices", "error-messages"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_radio_group, {
        modelValue: modelValue.value.selectDateType,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((modelValue.value.selectDateType) = $event)),
        class: "radio-group-row"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_radio, {
            value: "leaving",
            label: _unref(i18n).global.t('pages.common.filter.leaving'),
            color: "blue"
          }, null, 8, ["label"]),
          _createVNode(_component_v_radio, {
            value: "returning",
            label: _unref(i18n).global.t('pages.common.filter.returning'),
            color: "blue"
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(ValidationErrors, {
      messages: props.errors.end_date
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(RangeDatePicker, {
            modelValue: modelValue.value.dateRange,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((modelValue.value.dateRange) = $event)),
            maxRange: props.maxFilterDays,
            format: 'yyyy/MM/dd',
            isError: __props.errors.end_date?.length > 0
          }, null, 8, ["modelValue", "maxRange", "isError"])
        ])
      ]),
      _: 1
    }, 8, ["messages"])
  ]))
}
}

})